module.exports = __webpack_public_path__ + "static/media/Apple iPhone 5s Space Gray.fe400cff.png";